import Glue from 'Glue';
import * as R from 'remeda';
import { createSelector } from 'reselect';
import Types from 'Types';

export const domain = (state: Types.RootState) => state.glue.loading;

export const isLoading = createSelector(
  domain,
  (state: Types.RootState, ownProps: { types: Glue.LoadingType[] }) =>
    ownProps.types,
  (domain, types) => {
    const isLoading = R.pipe(
      types,
      R.find((type) => domain[type].status === 'loading'),
      R.isDefined,
    );

    return isLoading;
  },
);

// True if any registered LoadingType is currently 'loading'. Used by ambient
// indicators (e.g. the AppBar AnimatedLogo) that animate whenever the app is
// doing async work — boot, route data fetches, mutations.
//
// Reads every value in the domain dictionary rather than taking a `types`
// allow-list, so newly added LoadingTypes are picked up automatically.
export const isAnyLoading = createSelector(domain, (domain) =>
  R.pipe(
    Object.values(domain),
    R.find((value) => value.status === 'loading'),
    R.isDefined,
  ),
);

// Discrete status for a single LoadingType. Useful where `isLoading` (which
// collapses failed and idle into "not loading") loses information — e.g.
// the auth pages, which render a different UI per state.
export const status = createSelector(
  domain,
  (_state: Types.RootState, ownProps: { type: Glue.LoadingType }) =>
    ownProps.type,
  (domain, type) => domain[type].status,
);

// Stored error from the last failed run (whatever sagaWrapper caught — a
// Toast, Toast[], or raw Error).
export const error = createSelector(
  domain,
  (_state: Types.RootState, ownProps: { type: Glue.LoadingType }) =>
    ownProps.type,
  (domain, type) => domain[type].error,
);
